import * as React from 'react';

import type { VirtualNodeProps } from '@gitbook/slate-react';

import { EditorSectionIDsContext } from '../contexts';

/**
 * Virtual placeholder when tabs item is virtualized off screen.
 * We use a custom rendering to ensure we have an ID on the element.
 */
export function VirtualBlockTabsItem(props: VirtualNodeProps): React.ReactElement {
    const { node, children, style, attributes } = props;

    const { sections: sectionIDs } = React.useContext(EditorSectionIDsContext);
    const id = sectionIDs.get(node.key);

    return (
        <div ref={props.domRef} id={id} {...attributes} style={style}>
            {children}
        </div>
    );
}
